import { connect } from 'shared/node_modules/react-redux';
import SideMenu from './SideMenu';
import { setOnboardingHighlightedPosition } from 'shared/state/actions/currentOnboarding';

const mapStateToProps = ({ currentOnboarding: { currentStep } }) => {
  return {
    onboardingStep: currentStep,
  };
};

const mapDispatchToProps = {
  setOnboardingHighlightedPosition,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);
